import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {AbstractControl, ValidationErrors} from '@angular/forms';
import {debounceTime, first, map, switchMap} from 'rxjs/operators';
import {MachineGroupService} from '@services/administration/machine-group/machine-group.service';

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {

  private duplicatedNames: BehaviorSubject<string[]> = new BehaviorSubject([] as string[]);

  constructor(
    private machineGroupService: MachineGroupService
  ) {
  }

  public setDuplicatedNames(duplicatedNamesArr: string[]) {
    this.duplicatedNames.next(duplicatedNamesArr);
  }

  public duplicatedColumnsValidator(): (control: AbstractControl) => Observable<ValidationErrors | null> {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return this.duplicatedNames.pipe(
        debounceTime(100),
        map(value => {
        if (value.includes(control.value)) {
          return {duplicatedColumns: control.value};
        }
        return null;
      })).pipe(first());
    };
  }

  public JSONFormatValidator(): (control: AbstractControl) => (ValidationErrors | null) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      let error: ValidationErrors | null = null;
      try {
        JSON.parse(control.value);
      } catch (e: any) {
        error = {parseError: e.message};
      }
      return error;
    };
  }

  public duplicateMachineryGroupName(oldName: string = ''): (control: AbstractControl) => Observable<ValidationErrors | null> {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const checkingObservable = this.machineGroupService.isNameUsed(control.value)
        .pipe(map((result) => !result || oldName === control.value ? null : {duplicatedName: control.value}));
      return new Observable((sub) => sub.next({}))
        .pipe(debounceTime(500), switchMap(() => checkingObservable), first());
    };
  }
}
